import classNames from 'classnames'
import { transformCTAWithBackground } from 'marketing-site/src/transformers/elements/ContentfulCTALink'
import React from 'react'
import { Background } from '../../elements/Background'
import { CloseButton } from '../../elements/CloseButton'
import { CTALink } from '../../elements/CTALink/element'
import { Image } from '../../elements/Image/index'
import { Text } from '../../elements/Text'
import { VisuallyHidden } from '../../elements/VisuallyHidden'
import { Icon, renderIconSVG } from '../../utils'
import styles from './styles.scss'
import { IProps } from './index'
import useTranslate from '../../hooks/useTranslate'

export const ExitIntentPopupV2 = (props: IProps) => {
  const { translate } = useTranslate()

  const modalClassNames = classNames('exit-intent-modal', {
    open: props.isOpen,
  })

  return (
    <div>
      <section className={modalClassNames}>
        <Background theme={props.theme}>
          <div className="exit-intent-modal__close">
            <CloseButton onClick={props.onClose} />
            <VisuallyHidden>{translate('Close')}</VisuallyHidden>
          </div>
          <div className={'exit-intent-modal__content'}>
            <figure className="exit-intent-modal__image">
              <Image url={props.image.url} altText={props.image.altText} />
            </figure>
            <article className="exit-intent-modal__text">
              <header className="exit-intent-modal__header">
                <Text brand="default" size="heading-3">
                  {props.headline}
                </Text>
              </header>
              <div className="exit-intent-modal__text__points">
                <ul>
                  {props.checkmarks.map((text) => (
                    <li key={text}>
                      {renderIconSVG(Icon.Checkmark)}
                      {text}
                    </li>
                  ))}
                </ul>
              </div>
              <footer className="exit-intent-modal__footer">
                <CTALink
                  {...transformCTAWithBackground(props.cta)}
                  onClick={props.onCtaClicked}
                  wide={true}
                />
              </footer>
            </article>
          </div>
        </Background>
      </section>

      <style jsx>{styles}</style>
    </div>
  )
}
